import React, { useState } from 'react';
import { Modal, Input, Form, Button, notification } from 'antd';

const AuthModal = ({ visible, onOk, onCancel }) => {
  const [form] = Form.useForm();
  const [_api, setApi] = notification.useNotification();
  const [loading, setLoading] = useState(false);
  const setNotification=(config)=>{
    config.description = config.message;
    config.message = config.type;
      _api.open(config);
  }
  const handleSubmit = async () => {
    var status=-1;
    try {
      const values = await form.validateFields();
      setLoading(true);
      var res = await onOk(values.card,"change");
      if (res.data.code!== 200) {
        setNotification({
          type: 'error',
          message: res.data.msg || '卡密错误',
        });
        form.resetFields();
        status=res.data.code;
        return;
      }
    }catch(e){
      setNotification({
        type: 'error',
        message: e.message || '表单验证失败',
      })
    } finally {
      const values = await form.validateFields();
      setLoading(false);
      if (status!==200) return;
      window.localStorage.setItem("card", values.card);
      window.location.reload();
    }
  };

  return (
    <Modal
      title="请输入卡密"
      visible={visible}
      onOk={handleSubmit}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          取消
        </Button>,
        <Button 
          key="submit" 
          type="primary" 
          loading={loading}
          onClick={handleSubmit}
        >
          确定
        </Button>
      ]}
    >
      {setApi}
      <Form form={form} layout="vertical">
        <Form.Item
          name="card"
          label="卡密"
          rules={[{ required: true, message: '请输入卡密' }]}
        >
          <Input.Password placeholder="输入您的卡密" />
        </Form.Item>
        <p>获取卡密？<a href="https://www.douyin.com/user/MS4wLjABAAAARrat8FVcn-irSx52cHMx4EYYmI9RAoCplkMhVXXNegc?enter_from=discover&enter_method=chat_head&from_tab_name=main">点我联系站长</a></p>
      </Form>
    </Modal>
  );
};

export default AuthModal;